
export default class Session {
    static TOKEN_KEY = "SIMPLEJAY_API_PAGE_TOKEN";
    static token = (localStorage.getItem(this.TOKEN_KEY) === null ? "" : localStorage.getItem(this.TOKEN_KEY));
    static verified = false;

    static isLocalhost = window.location.hostname.includes("localhost");
    static isStaging = window.location.hostname.includes(".admin.simplejay.com");
    static apiBaseurl = (this.isLocalhost ? "http://localhost:9000" : (this.isStaging ? "https://" + window.location.hostname.split(".")[0] + ".api.simplejay.com" : "https://api.simplejay.com"));

    static users: any[] = [];
    static organizations: any[] = [];
    static providers: any[] = [];
    static deployments: any[] = [];
    static applications: any[] = [];
    static taskFunctions: any[] = [];
    static editingSchema: any = {};

    static googleLoginHook: any = undefined;

    // Undefined means has no yet been checked.
    // "" means no user is logged in.
    // Otherwise it is the user object.
    static currentUser: any = undefined;
    static verifying = false;

    static loginDialog: any = undefined;
    static app: any = undefined;
    static drawerOpen = localStorage.getItem("drawerOpen") !== 'false';
    static navigate: any = undefined;
    static redirectPath: string = "";
    static forcePageUpdateHook: any = undefined;

    static ws: any = null;
    static wsHook: any = {};
    static wsSubscriptions: any = [];
    static ws_connections = {};
    static ws_interval: any = null;

    static api(method: string, path: string, data = {}, setResult: any = null, setError: any = null, postRaw = false, backdrop = true) {
        if (backdrop === true) {
            this.app.setState({
                backdropOpen: true
            });
            // this.app.setBackdropOpen(true);
        }

        let headers: { [key: string]: string } = {
            'Content-Type': 'application/json'
        };

        if (this.token !== "") {
            headers["Authorization"] = "Bearer " + this.token;
        }

        if (data instanceof FormData) {
            // If it's a form, this will be automagically set.
            delete headers["Content-Type"];
        }

        const controller = new AbortController();

        const timer = setTimeout(() => {
            controller.abort();
            this.app.setState({
                backdropOpen: false
            });

            // this.app.setBackdropOpen(false);
            // this.app.closeBackdrop();

            let message = method + " " + path + " timeout!"
            if (setError === null) {
                this.app.setState({
                    snackbarOpen: true,
                    snackbarSeverity: "error",
                    message: message
                });
                // this.app.setSnackbarSeverity("error");
                // this.app.setMessage(message);
                // this.app.setSnackbarOpen(true);
                // this.app.openSnackbar("error", message);
            } else {
                setError(message);
            }
        }, 60 * 10 * 1000); // Ten minute timeout.

        var body: any = undefined;
        if (postRaw) {
            body = data;
        } else if (method.toLowerCase() === "put" || method.toLowerCase() === "post") {
            body = JSON.stringify(data);
        }

        fetch(this.apiBaseurl + path, {
            signal: controller.signal,
            method: method,
            headers: headers,
            body: body
        }).then((response) => {
            clearTimeout(timer);
            return response.text().then((response_text) => {
                this.app.setState({
                    backdropOpen: false
                })
                // if (backdrop) {
                //     this.app.openBackdrop();
                // }
                let message = null;
                let data = undefined;

                try {
                    data = JSON.parse(response_text);
                    if (data.detail) {
                        message = data.detail;
                    }
                    if (typeof data === "string") {
                        data = response_text;
                    }
                } catch (err) {
                    if (typeof data === "undefined") {
                        data = response_text;
                    }
                }


                if (response.ok) {
                    // this.app.setState({
                    //     backdropOpen: false
                    // });
                    // this.app.setBackdropOpen(false);
                    // this.app.closeBackdrop();

                    if (message) {
                        this.app.setState({
                            snackbarOpen: true,
                            snackbarSeverity: "success",
                            message: message
                        });
                        // this.app.setSnackbarSeverity("success");
                        // this.app.setMessage(message);
                        // this.app.setSnackbarOpen(true);
                        // this.app.openSnackbar("success", message);
                    }
                    if (setResult !== null) {
                        setResult(data);
                    }
                } else {
                    // this.app.setState({
                    //     backdropOpen: false
                    // });
                    // this.app.setBackdropOpen(false);
                    // this.app.closeBackdrop();

                    let message: any = response.status + " " + response.statusText;
                    if (typeof (data.detail) === "undefined") {
                        message = "API is temporarily unavailable."
                    } else {
                        try {
                            message = data.detail;
                            if (typeof (message) !== "string") {
                                if (message instanceof Array && message.length > 0) {
                                    if ("loc" in message[0] && message[0]["loc"].length > 1 && "type" in message[0]) {
                                        if (message[0]["type"] === "value_error.missing") {
                                            message = "Field '" + message[0]["loc"][1] + "' is missing.";
                                        }
                                    }
                                }
                                if (typeof (message) !== "string") {
                                    message = JSON.stringify(message);
                                }
                            }
                        } catch (err) {
                            // pass
                        }
                    }

                    if (setError === null) {
                        this.app.setState({
                            snackbarOpen: true,
                            snackbarSeverity: "error",
                            message: message
                        });
                        // this.app.setSnackbarSeverity("error");
                        // this.app.setMessage(message);
                        // this.app.setSnackbarOpen(true);
                        // this.app.openSnackbar("error", message);
                    } else {
                        setError(message);
                    }
                    if (response.status === 403) {
                        if (this.isLocalhost) {
                            console.log("403: Successful request; unauthorized: " + path);
                        }
                        this.clearToken();
                        setTimeout(function(){
                            window.location.reload();
                        }, 1000);
                    }
                }
            }).catch(error => {
                console.log("Could not read response.text()?");
                console.log(error);

                clearTimeout(timer);
                this.app.setState({
                    backdropOpen: false
                });
                // this.app.setBackdropOpen(false);
                // this.app.closeBackdrop();

                let message = "Other error.";

                if (setError === null) {
                    this.app.setState({
                        snackbarOpen: true,
                        snackbarSeverity: "error",
                        message: message
                    });
                    // this.app.setSnackbarSeverity("error");
                    // this.app.setMessage(message);
                    // this.app.setSnackbarOpen(true);
                    // this.app.openSnackbar("error", message);
                } else {
                    setError(message);
                }
            });
        }).catch(error => {
            console.log(`Could not fetch ${method} ${this.apiBaseurl}${path}`);
            console.log(error);

            clearTimeout(timer);
            this.app.setState({
                backdropOpen: false
            });
            // this.app.setBackdropOpen(false);
            // this.app.closeBackdrop();

            let message = "Unknown error fetching. Check console.";
            try {
                message = error.message;
                if (message === "Failed to fetch") {
                    message = "API is temporarily unavailable.";
                }
            } catch (err) {
                // pass
            }

            if (setError === null) {
                this.app.setState({
                    snackbarOpen: true,
                    snackbarSeverity: "error",
                    message: message
                });
                // this.app.setSnackbarSeverity("error");
                // this.app.setMessage(message);
                // this.app.setSnackbarOpen(true);
                // this.app.openSnackbar("error", message);
            } else {
                setError(message);
            }

            if (error.status === 403) {
                if (this.isLocalhost) {
                    console.log("403: Unsuccessful request; unauthorized: " + path);
                }
                this.clearToken();
                setTimeout(function(){
                    window.location.reload();
                }, 1000);
            }
        });
    }

    static login(email: string, password: string, setResult: any, setError: any) {
        this.api("POST", "/login", {
            email: email,
            password: password
        }, setResult, setError, false);
    }

    static googleLogin(access_token: string, setResult: any, setError: any) {
        this.api("POST", "/google_login", {
            access_token: access_token
        }, setResult, setError, false);
    }

    static rerunTask(task: any) {
        this.api("POST", "/tasks/", {
            name: task.name,
            function: task.function,
            parameters: task.parameters
        });
    }

    static verify_token(login = true, snackbar = false) {
        if (this.isLocalhost) {
            console.log(`VERIFY TOKEN ${login} ${snackbar}`)
        }
        this.verifying = true;
        if (this.token !== "" && !this.verified) {
            this.api("GET", "/me", {}, (result: any) => {
                this.currentUser = result;
                if (this.currentUser.roles) {
                    for (const role of this.currentUser.roles) {
                        if (role.name === "Administrator") {
                            this.currentUser.isAdmin = true;
                            break;
                        }
                    }
                }
                if (snackbar) {
                    if (this.isLocalhost) {
                        console.log("Verify: Success. Snackbor Open");
                    }
                    this.app.setState({
                        snackbarOpen: true,
                        snackbarSeverity: "success",
                        message: "Welcome!"
                    });
                    // this.app.setSnackbarSeverity("success");
                    // this.app.setMessage("Welcome!");
                    // this.app.setSnackbarOpen(true);
                    // this.app.openSnackbar("success", "Welcome!");
                    if (this.forcePageUpdateHook) {
                        this.forcePageUpdateHook.componentDidMount();
                        this.forcePageUpdateHook = null;
                    }
                }
                this.verified = true;
                this.verifying = false;
                this.loginDialog.close();
            }, (error: any) => {
                this.currentUser = undefined;
                if (Session.isLocalhost) {
                    console.log("Login Failed:");
                    console.log(error);
                }
                if (snackbar) {
                    this.app.setState({
                        snackbarOpen: true,
                        snackbarSeverity: "error",
                        message: error.message
                    });
                    // this.app.setSnackbarSeverity("error");
                    // this.app.setMessage(message);
                    // this.app.setSnackbarOpen(true);
                    // this.app.openSnackbar("error", message);
                }
                this.clearToken();
                setTimeout(function(){
                    window.location.reload();
                }, 1000);
            });
        }

        if (this.token === "") {
            this.currentUser = undefined;
            if (login) {
                this.loginDialog.setOpen(true);
            }
        }
    }

    static clearToken() {
        localStorage.clear();
        sessionStorage.clear();
        this.token = "";
        this.verified = false;
        this.verifying = true;
    }
}

// function reloadWebsocket() {
//     clearInterval(Session.ws_interval);


//     let url = "wss://ws.simplejay.com:10000";
//     if (Session.isLocalhost) {
//         url = "ws://localhost:10000";
//     } else if (Session.isStaging) {
//         let host_parts = window.location.hostname.split(".");
//         url = "wss://" + host_parts[0] + ".api.simplejay.com:10000";
//     }
//     let ping = 1;

//     console.log("Reconnecting Websocket " + url);
//     Session.ws = new WebSocket(url);

//     Session.ws.onopen = function (event: any) {
//         console.log(event);
//         console.log("Websocket Opened.");
//         Session.wsSubscriptions.forEach((subscription: any) => {
//             Session.ws.send(subscription);
//             console.log("Subscribed to " + subscription);
//         });
//     };
//     Session.ws.onmessage = function (event: any) {
//         try {
//             let eventData = JSON.parse(event.data);
//             if (eventData.type in Session.wsHook) {
//                 Session.wsHook[eventData.type](eventData);
//             }
//         } catch (err) {
//             console.log(event);
//         }
//     };
//     Session.ws.onclose = function (event: any) {
//         console.log(event);
//         console.log("Websocket Closed.");
//     };
//     Session.ws.onerror = function (event: any) {
//         console.log(event);
//         console.log("Websocket Error.");
//     };

//     Session.ws_interval = setInterval(function () {
//         if (Session.ws.readyState === WebSocket.CLOSED) {
//             reloadWebsocket();
//             console.log("Websocket Connecting...");
//             Session.ws = new WebSocket(url);
//         } else if (Session.ws.readyState === WebSocket.OPEN) {
//             console.log("Websocket Connected / Open. Sending ping...");
//             Session.ws.send("ping " + ping);
//             ping += 1;
//         } else if (Session.ws.readyState === WebSocket.CONNECTING) {
//             console.log("Websocket Connecting...");
//         } else if (Session.ws.readyState === WebSocket.CLOSING) {
//             console.log("Websocket Closing...");
//         } else {
//             console.log("Websocket Unknown State..." + Session.ws.readyState);
//         }
//     }, 1000);

//     console.log("Connected!");
// }

declare global {
    interface Window {
        Session:any;
    }
}

if (Session.isLocalhost) {
    console.log("Session.apiBaseurl: " + Session.apiBaseurl);
    console.log("Session.isLocalhost: " + Session.isLocalhost);
    console.log("Session.token: " + Session.token);
    console.log(document.baseURI);
    // reloadWebsocket();
    window.Session = Session;
}

